/**
 * Size ceilings for files attached to an AI chat. Attachments are sent inline
 * as base64 in the request body, so these keep a single message from blowing
 * past provider payload limits (and the browser's memory) — they are not the
 * limits for importing a file into the sheet, which live in `fileSizeLimits`.
 */
export const MAX_CHAT_IMAGE_SIZE_MB = 5;
export const MAX_CHAT_PDF_SIZE_MB = 50;
